import { render } from "./AuditingModuleTab.vue?vue&type=template&id=6120ca1e&scoped=true&ts=true"
import script from "./AuditingModuleTab.vue?vue&type=script&lang=ts"
export * from "./AuditingModuleTab.vue?vue&type=script&lang=ts"

import "./AuditingModuleTab.vue?vue&type=style&index=0&id=6120ca1e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6120ca1e"]])

export default __exports__